import { useState } from 'react';

import useInterval from '@/hooks/useInterval';
import emailVerificationConstants from '@/v2/domains/Auth/constants/emailVerificationConstants';

export default function useResendCooldown() {
  const [secondsLeft, setSecondsLeft] = useState(0);

  const tickDelay = secondsLeft ? emailVerificationConstants.oneSecondMs : null;

  useInterval(() => setSecondsLeft(secondsLeft - 1), tickDelay);

  const startCooldown = () =>
    setSecondsLeft(emailVerificationConstants.resendCooldownSeconds);

  return { secondsLeft, startCooldown };
}
